(function () {
  var section = document.querySelector('[data-cart-section]');
  if (!section) return;

  var status = section.querySelector('[data-cart-status]');
  var quantityInputs = section.querySelectorAll('[data-cart-quantity]');

  function publish(name, detail) {
    if (window.PettiChat && typeof window.PettiChat.publish === 'function') window.PettiChat.publish(name, detail || {});
    else document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
  }

  quantityInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      var line = Number(input.dataset.line);
      var quantity = Math.max(0, Number(input.value) || 0);
      input.disabled = true;
      if (status) status.textContent = 'Updating…';

      var routes = (window.PettiChat && window.PettiChat.routes) || {};
      fetch((routes.cartChange || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart update failed');
          return response.json();
        })
        .then(function (cart) {
          publish('pettichat_cart_updated', { cart: cart, line: line, quantity: quantity });
          window.location.reload();
        })
        .catch(function () {
          input.disabled = false;
          if (status) status.textContent = 'Unable to update. Use the Update cart button.';
        });
    });
  });

  section.querySelectorAll('[data-cart-remove]').forEach(function (link) {
    link.addEventListener('click', function () {
      publish('pettichat_cart_remove_intent', {
        line: Number(link.dataset.line),
        variant_id: Number(link.dataset.variantId)
      });
    });
  });

  var form = section.querySelector('form');
  if (form) {
    form.addEventListener('submit', function (event) {
      if (event.submitter && event.submitter.name === 'checkout') {
        publish('pettichat_checkout_intent', {
          item_count: Number(section.dataset.cartItemCount || 0),
          value: Number(section.dataset.cartTotal || 0) / 100,
          currency: section.dataset.cartCurrency
        });
      }
    });
  }

  publish('pettichat_cart_viewed', {
    item_count: Number(section.dataset.cartItemCount || 0),
    value: Number(section.dataset.cartTotal || 0) / 100,
    currency: section.dataset.cartCurrency,
    cart_url: window.location.pathname
  });
})();
